//chime
let chime = [];
chime.push({ key: 0, value: "Boot" });
chime.push({ key: 1, value: "OTA Success" });
chime.push({ key: 2, value: "OTA Failure" });
chime.push({ key: 3, value: "Setup Completion" });
chime.push({ key: 4, value: "General TCP Failure" });
chime.push({ key: 5, value: "Daily Report" });
chime.push({ key: 6, value: "Settings Update Command Received" });
chime.push({ key: 7, value: "Status Report Send Failure" });
chime.push({ key: 8, value: "Status Report Log Send Failure" });
chime.push({ key: 9, value: "TCP Connection Failure" });
chime.push({ key: 10, value: "Pre OTA" });
chime.push({ key: 11, value: "TCP Authentication Failure" });
chime.push({ key: 13, value: "After Chime" });

//chime pro
let chimePro = [];
chimePro.push({ key: 0, value: "Boot" });
chimePro.push({ key: 1, value: "OTA Success" });
chimePro.push({ key: 2, value: "OTA Failure" });
chimePro.push({ key: 3, value: "Setup Completion" });
chimePro.push({ key: 4, value: "General TCP Failure" });
chimePro.push({ key: 5, value: "Daily Report" });
chimePro.push({ key: 6, value: "Settings Update Command Received" });
chimePro.push({ key: 7, value: "Wi-Fi Down" });
chimePro.push({ key: 8, value: "Rogue Device Report" });
chimePro.push({ key: 9, value: "TCP Connection Failure" });
chimePro.push({ key: 10, value: "Pre OTA" });
chimePro.push({ key: 11, value: "After Chime" });
chimePro.push({ key: 12, value: "Auto-Provision Complete" });
chimePro.push({ key: 13, value: "Throughput Test Report" });
chimePro.push({ key: 14, value: "Stream Monitor" });
chimePro.push({ key: 15, value: "Network Recovered" });
chimePro.push({ key: 32, value: "Network Switched" });

//doorbell / doorboot
let doorbell = [];
doorbell.push({ key: 0, value: "Unassigned/Unknown" });
doorbell.push({ key: 1, value: "After Ding" });
doorbell.push({ key: 2, value: "After Setup" });
doorbell.push({ key: 3, value: "After OTA" });
doorbell.push({ key: 4, value: "After Motion" });
doorbell.push({ key: 5, value: "Low Battery Shutdown" });
doorbell.push({ key: 6, value: "Low Temperature Shutdown" });
doorbell.push({ key: 7, value: "Battery Full Alert" });
doorbell.push({ key: 8, value: "Weather Alert" });
doorbell.push({ key: 9, value: "Daily Report" });
doorbell.push({ key: 10, value: "After Boot/Reset" });
doorbell.push({ key: 11, value: "After Live View" });
doorbell.push({ key: 12, value: "Battery Charge Status" });
doorbell.push({ key: 13, value: "After IPerf Test" });
doorbell.push({ key: 14, value: "Network Disconnected" });
doorbell.push({ key: 15, value: "Network Connected" });
doorbell.push({ key: 16, value: "Service Disconnected" });
doorbell.push({ key: 17, value: "Service Connected" });
doorbell.push({ key: 18, value: "Failed OTA" });
doorbell.push({ key: 19, value: "Power On" });
doorbell.push({ key: 20, value: "Pre OTA" });
doorbell.push({ key: 21, value: "Daily Status Report Failed to Send" });
doorbell.push({ key: 22, value: "WiFi Calibrated (on OTA)" });
doorbell.push({ key: 23, value: "Aborted Call" });
doorbell.push({ key: 24, value: "Pre OTA" });
doorbell.push({ key: 25, value: "Knock Event" });
doorbell.push({ key: 27, value: "Cable Connected/Disconnected" });
doorbell.push({ key: 28, value: "DKAD Result" });
doorbell.push({ key: 29, value: "EXT_PWR_CHANGE" });
doorbell.push({ key: 30, value: "E2EE Setup Success" });
doorbell.push({ key: 31, value: "E2EE Setup Failed" });
doorbell.push({ key: 32, value: "Network Switched" });
doorbell.push({ key: 128, value: "Country Code Changed" });

//lpd_v1
let lpd = [];
lpd.push({ key: 0, value: "Unassigned/Unknown" });
lpd.push({ key: 1, value: "After Ding" });
lpd.push({ key: 2, value: "After Setup" });
lpd.push({ key: 3, value: "After OTA" });
lpd.push({ key: 4, value: "After Motion" });
lpd.push({ key: 5, value: "Low Battery Shutdown" });
lpd.push({ key: 6, value: "Low Temperature Shutdown" });
lpd.push({ key: 7, value: "Periodic Status Report" });
lpd.push({ key: 8, value: "Weather Alert" });
lpd.push({ key: 9, value: "Daily Report" });
lpd.push({ key: 10, value: "After Boot/Reset" });
lpd.push({ key: 11, value: "After Live View" });
lpd.push({ key: 12, value: "Battery Charge Status" });
lpd.push({ key: 13, value: "After IPerf Test" });
lpd.push({ key: 14, value: "Network Disconnected" });
lpd.push({ key: 15, value: "Network Connected" });
lpd.push({ key: 16, value: "Service Disconnected" });
lpd.push({ key: 17, value: "Service Connected" });
lpd.push({ key: 18, value: "Failed OTA" });
lpd.push({ key: 19, value: "Power On" });
lpd.push({ key: 20, value: "Pre OTA" });
lpd.push({ key: 21, value: "Power Down" });
lpd.push({ key: 22, value: "E2EE Success" });
lpd.push({ key: 23, value: "E2EE Failure" });
lpd.push({ key: 24, value: "Path Creation" });
lpd.push({ key: 25, value: "Waypoint Creation" });
lpd.push({ key: 26, value: "Flight" });
lpd.push({ key: 27, value: "Device Health" });
lpd.push({ key: 28, value: "Pre FC Upgrade" });
lpd.push({ key: 29, value: "Post FC Upgrade" });
lpd.push({ key: 30, value: "Failed FC Upgrade" });
lpd.push({ key: 31, value: "Pre ESC Upgrade" });
lpd.push({ key: 32, value: "Post ESC Upgrade" });
lpd.push({ key: 33, value: "Failed ESC Upgrade" });
lpd.push({ key: 34, value: "FC Boot" });
lpd.push({ key: 35, value: "Local Drive Failure" });
lpd.push({ key: 36, value: "BLE presence detected" });
lpd.push({ key: 37, value: "Post Streaming Session" });
lpd.push({ key: 38, value: "Post File Upload" });
lpd.push({ key: 39, value: "High Temperature Shutdown" });
lpd.push({ key: 40, value: "High Power Drive Mode" });
lpd.push({ key: 41, value: "High Power Guard Mode" });
lpd.push({ key: 42, value: "Low Power Guard Mode" });
lpd.push({ key: 43, value: "Privacy Cover Moved" });
lpd.push({ key: 44, value: "Vehicle Collision Data" });
lpd.push({ key: 45, value: "Network Changed" });
lpd.push({ key: 46, value: "Fix Acquired" });
lpd.push({ key: 47, value: "Unexpected Power Loss" });
lpd.push({ key: 48, value: "Impact" });
lpd.push({ key: 49, value: "Disturbance" });
lpd.push({ key: 50, value: "Movement Inside" });
lpd.push({ key: 51, value: "Loud Noise" });
lpd.push({ key: 52, value: "Created Clip" });
lpd.push({ key: 53, value: "Geofence Entry" });
lpd.push({ key: 54, value: "Geofence Exit" });
lpd.push({ key: 55, value: "Siren Activated" });
lpd.push({ key: 56, value: "Siren Deactivated" });
lpd.push({ key: 57, value: "Location Sharing Enabled" });
lpd.push({ key: 58, value: "Location Sharing Disabled" });
lpd.push({ key: 59, value: "Location Data Deleted" });
lpd.push({ key: 60, value: "GPS Metrics" });
lpd.push({ key: 61, value: "Calibration" });
lpd.push({ key: 62, value: "BLE Presence Lost" });
lpd.push({ key: 63, value: "Connectivity Metrics" });
lpd.push({ key: 64, value: "Drive Started" });
lpd.push({ key: 65, value: "Drive Ended" });
lpd.push({ key: 66, value: "Post P2P VOD" });
lpd.push({ key: 67, value: "Post P2P Playback" });
lpd.push({ key: 68, value: "OTA status" });
lpd.push({ key: 69, value: "Delete Local Video" });
lpd.push({ key: 70, value: "Vehicle Motion" });
lpd.push({ key: 71, value: "Pre Reboot" });
lpd.push({ key: 72, value: "Modem Reboot" });
lpd.push({ key: 73, value: "Ota Start" });
lpd.push({ key: 74, value: "Traffic Stop" });
lpd.push({ key: 75, value: "Thermal Policy" });
lpd.push({ key: 76, value: "Setup Stats" });
lpd.push({ key: 77, value: "Metrics" });
lpd.push({ key: 78, value: "Recording 24x7" });

//zeus
let zeus = [];
zeus.push({ key: 0, value: "Unassigned/Unknown" });
zeus.push({ key: 1, value: "After Ding" });
zeus.push({ key: 2, value: "After Setup" });
zeus.push({ key: 3, value: "After OTA" });
zeus.push({ key: 4, value: "After Motion" });
zeus.push({ key: 5, value: "Low Battery Shutdown" });
zeus.push({ key: 6, value: "Low Temperature Shutdown" });
zeus.push({ key: 7, value: "Periodic Status Report" });
zeus.push({ key: 8, value: "Weather Alert" });
zeus.push({ key: 9, value: "Daily Report" });
zeus.push({ key: 10, value: "After Boot/Reset" });
zeus.push({ key: 11, value: "After Live View" });
zeus.push({ key: 12, value: "Battery Charge Status" });
zeus.push({ key: 13, value: "After IPerf Test" });
zeus.push({ key: 14, value: "Network Disconnected" });
zeus.push({ key: 15, value: "Network Connected" });
zeus.push({ key: 16, value: "Service Disconnected" });
zeus.push({ key: 17, value: "Service Connected" });
zeus.push({ key: 20, value: "Pre OTA" });
zeus.push({ key: 21, value: "Power Down" });
zeus.push({ key: 22, value: "After Path Creation" });
zeus.push({ key: 23, value: "After Waypoint Creation" });
zeus.push({ key: 24, value: "After Flight" });
zeus.push({ key: 28, value: "Pre FC Upgrade" });
zeus.push({ key: 29, value: "Post FC Upgrade" });
zeus.push({ key: 30, value: "Failed FC Upgrade" });
zeus.push({ key: 31, value: "Pre ESC Upgrade" });
zeus.push({ key: 32, value: "Post ESC Upgrade" });
zeus.push({ key: 33, value: "Failed ESC Upgrade" });
zeus.push({ key: 34, value: "FC Boot" });
zeus.push({ key: 61, value: "Calibration" });

//stickup_cam
let cam = [];
cam.push({ key: 0, value: "Unassigned/Unknown" });
cam.push({ key: 1, value: "After Ding" });
cam.push({ key: 2, value: "After Setup" });
cam.push({ key: 3, value: "After OTA" });
cam.push({ key: 4, value: "After Motion" });
cam.push({ key: 5, value: "Low Battery Shutdown" });
cam.push({ key: 6, value: "Low Temperature Shutdown" });
cam.push({ key: 7, value: "Battery Full Alert" });
cam.push({ key: 8, value: "Weather Alert" });
cam.push({ key: 9, value: "Daily Report" });
cam.push({ key: 10, value: "After Boot/Reset" });
cam.push({ key: 11, value: "After Live View" });
cam.push({ key: 12, value: "Battery Charge Status" });
cam.push({ key: 13, value: "After IPerf Test" });
cam.push({ key: 14, value: "Network Disconnected" });
cam.push({ key: 15, value: "Network Connected" });
cam.push({ key: 16, value: "Service Disconnected" });
cam.push({ key: 17, value: "Service Connected" });
cam.push({ key: 18, value: "Failed OTA" });
cam.push({ key: 19, value: "Power On" });
cam.push({ key: 20, value: "Hatch State Change" });
cam.push({ key: 21, value: "Daily Status Report Failed to Send" });
cam.push({ key: 22, value: "WiFi Calibrated (on OTA)" });
cam.push({ key: 23, value: "Aborted Call" });
cam.push({ key: 24, value: "Pre OTA" });
cam.push({ key: 29, value: "EXT_PWR_CHANGE" });
cam.push({ key: 30, value: "E2EE Setup Success" });
cam.push({ key: 31, value: "E2EE Setup Failed" });
cam.push({ key: 32, value: "Network Switched" });
cam.push({ key: 33, value: "24x7 Recording" });
cam.push({ key: 128, value: "Country Code Changed" });

//cocoa devices
let cocoa = [];
cocoa.push({ key: 0, value: "Context Unknown" });
cocoa.push({ key: 1, value: "Post Ding" });
cocoa.push({ key: 2, value: "Post Setup" });
cocoa.push({ key: 3, value: "Post OTA" });
cocoa.push({ key: 4, value: "Post Motion" });
cocoa.push({ key: 5, value: "Low Battery Shutdown" });
cocoa.push({ key: 6, value: "Low Temperature Shutdown" });
cocoa.push({ key: 7, value: "Battery Full Alert" });
cocoa.push({ key: 8, value: "Weather Alert" });
cocoa.push({ key: 9, value: "Daily Report" });
cocoa.push({ key: 10, value: "Boot" });
cocoa.push({ key: 11, value: "Post VOD" });
cocoa.push({ key: 12, value: "Battery Charge Status" });
cocoa.push({ key: 13, value: "Post iPerf" });
cocoa.push({ key: 14, value: "Network Disconnected" });
cocoa.push({ key: 15, value: "Network Connected" });
cocoa.push({ key: 16, value: "Service Disconnected" });
cocoa.push({ key: 17, value: "Service Connected" });
cocoa.push({ key: 18, value: "OTA Failure" });
cocoa.push({ key: 19, value: "Power On" });
cocoa.push({ key: 20, value: "Pre OTA" });
cocoa.push({ key: 21, value: "Status Report Send Failure" });
cocoa.push({ key: 22, value: "E2EE Success" });
cocoa.push({ key: 23, value: "E2EE Failure" });
cocoa.push({ key: 24, value: "OTA Start" });
cocoa.push({ key: 25, value: "Knock Event" });
cocoa.push({ key: 27, value: "Cable Connected/Disconnected" });
cocoa.push({ key: 28, value: "OTA Status" });
cocoa.push({ key: 29, value: "Device RPC Test" });
cocoa.push({ key: 30, value: "Door Unlock Test" });
cocoa.push({ key: 31, value: "Setup Stats" });
cocoa.push({ key: 32, value: "Network Switched" });
cocoa.push({ key: 78, value: "24x7 Recording" });
cocoa.push({ key: 128, value: "Country Code Change" });

//mars devices (df_doorbell_clownfish, stickup_cam_mini_ptz_v1, stickup_cam_mini_v2)
let mars = [];
mars.push({ key: 0, value: "Context Unknown" });
mars.push({ key: 1, value: "Post Ding" });
mars.push({ key: 2, value: "Post Setup" });
mars.push({ key: 3, value: "Post OTA" });
mars.push({ key: 4, value: "Post Motion" });
mars.push({ key: 6, value: "Low Temp Shutdown" });
mars.push({ key: 9, value: "Daily Report" });
mars.push({ key: 10, value: "Boot" });
mars.push({ key: 11, value: "Post VOD" });
mars.push({ key: 12, value: "Charged Battery" });
mars.push({ key: 13, value: "Post iPerf" });
mars.push({ key: 15, value: "Network Connected" });
mars.push({ key: 18, value: "OTA Failure" });
mars.push({ key: 19, value: "Power On" });
mars.push({ key: 21, value: "Status Report Send Failure" });
mars.push({ key: 22, value: "E2EE Success" });
mars.push({ key: 23, value: "E2EE Failure" });
mars.push({ key: 24, value: "Pre OTA" });
mars.push({ key: 28, value: "OTA Status" });
mars.push({ key: 29, value: "Device RPC Test" });
mars.push({ key: 30, value: "Door Unlock" });
mars.push({ key: 31, value: "Setup Stats" });
mars.push({ key: 32, value: "Privacy Shutter Status Changed" });
mars.push({ key: 39, value: "High Temperature Shutdown" });
mars.push({ key: 78, value: "24x7 Recording" });
mars.push({ key: 128, value: "Country Code Change" });
mars.push({ key: 129, value: "Battery Stress Report" });

function replacePair(items, customPair) {
  let filteredItems = items.filter((pair) => pair.key !== customPair.key);
  filteredItems.push({ key: customPair.key, value: customPair.value });
  filteredItems.sort((a, b) => a.key - b.key);
  return filteredItems;
}

export default {
  doorbot: doorbell,
  doorbell: doorbell,
  chime_pro: chimePro,
  chime_v2: chime,
  chime: chime,
  stickup_cam: cam,
  stickup_cam_lunar: cam,
  stickup_cam_longfin: cam,
  stickup_cam_elite: lpd,
  stickup_cam_mini: lpd,
  stickup_cam_mini_v2: replacePair(lpd, {
    key: 31,
    value: "Setup Status",
  }),
  spotlightw_poe: lpd,
  spotlightw: lpd,
  floodlight: lpd,
  lpd: lpd,
  always_home_camera: zeus,
  hp_cam: lpd,
  jbox: lpd,
  rccs_1p_jaws: lpd,
  cocoa_camera: cocoa,
  cocoa_camera_v2: cocoa,
  cocoa_camera_v3: cocoa,
  cocoa_doorbell: cocoa,
  cocoa_doorbell_v2: cocoa,
  cocoa_doorbell_v3: cocoa,
  cocoa_floodlight: cocoa,
  cocoa_spotlight: cocoa,
  cocoa_dashcam: cocoa,
  df_doorbell_clownfish: mars,
  stickup_cam_mini_ptz_v1: mars,
  stickup_cam_mini_ptz: mars,
  floodlight_pro: lpd,
};

/*function getEventContextByType(type) {
  const sanitized = type.replace(/_v\d+$/i, '')

  return deviceContexts[sanitized] || deviceContexts['doorbell'];
}*/
